// extracted by mini-css-extract-plugin
export default {"root":"DropPlace-module_root__fU1iw","active":"DropPlace-module_active__CenBp","available":"DropPlace-module_available__v9nsE","hovered":"DropPlace-module_hovered__RAYW8"};